import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import "./Arxiv.scss"

const Arxiv3 = () => {
  const arxiv = [
    {
      id: 1,
      materialName: "alvido_qurol_ernest_xemenguej",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/alvido_qurol_ernest_xemenguej.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 2,
      materialName: "asqad_muxtor_chinor_romani",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/asqad_muxtor_chinor_romani_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 3,
      materialName: "axmad_azam_hali_hayot_bor_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/axmad_azam_hali_hayot_bor_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 4,
      materialName: "ayyor_quyoncha_haqida_ertak",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/ayyor_quyoncha_haqida_ertak.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 5,
      materialName: "BaliqchilikAsoslari",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/BaliqchilikAsoslari.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 6,
      materialName: "burgutlar",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/burgutlar.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 7,
      materialName: "erkin_azam_suv_yoqalab",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_azam_suv_yoqalab.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 8,
      materialName: "erkin_va_farovon_demokratik_ozbekiston_davlatini_birgalikda_barpo_etamiz",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_va_farovon_demokratik_ozbekiston_davlatini_birgalikda_barpo_etamiz.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 9,
      materialName: "erkin_voxidov_soz_latofati_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_voxidov_soz_latofati_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 10,
      materialName: "gabriel_garsia_markes_yolgizlikning_yuz_jili_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/gabriel_garsia_markes_yolgizlikning_yuz_jili_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 11,
      materialName: "iqrornoma_lev_tolstoj",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/iqrornoma_lev_tolstoj.pdf",
      roll: ['public'],
      categories: ['student']
    },
  ]
  const [arxivSoni, setArxivSoni] = useState(0)
  const soniArxiv = () => {
    setArxivSoni(arxivSoni + 1)
    console.log(arxivSoni);
    JSON.stringify(localStorage.setItem("arxivBoshqa", arxivSoni))
  }
  console.log(arxiv);
  const [pdf, setPdf] = useState(arxiv)
  return (
    <div>
      {/* {arxivSoni} */}
      {
        pdf.map((item) => {
          return <div className='kitob'>
            <Accordion className='Accordion'>
              <AccordionSummary
                // expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ color: "black" }}
              >
                <Typography>
                  <div className='block'>
                    <div>
                      {item.id} -- {item.materialName}
                    </div>
                    {item.file}
                    <Link  to={item.file_name} className='korish' target="_blank">Ko'rish</Link>
                  </div>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography style={{display:"flex",alignItems:"center"}}>
                 {/* <h4 style={{color:"red"}}>Muallifi:</h4>  <h5>{ item?.author}</h5> */}
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Link onClick={soniArxiv} to={item.file_name} className='havola' target="_blank" download>Ko'chirish</Link>

          </div>
        })
      }
    </div>
  );
}

export default Arxiv3;
